(function () {
  const SCROLL_THRESHOLD = 700;
  const MOBILE_MAX_WIDTH = 767;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function updateStickyCtaVisibility(stickyCta) {
    if (!stickyCta) return;
    const show = isMobile() && window.scrollY >= SCROLL_THRESHOLD;
    if (show) {
      stickyCta.classList.add('is-visible');
      stickyCta.removeAttribute('hidden');
      stickyCta.setAttribute('aria-hidden', 'false');
    } else {
      stickyCta.classList.remove('is-visible');
      stickyCta.setAttribute('hidden', '');
      stickyCta.setAttribute('aria-hidden', 'true');
    }
  }

  function syncStickyButtonLoading(stickyBtn, mainSubmitBtn) {
    if (!stickyBtn || !mainSubmitBtn) return;
    const isLoading = mainSubmitBtn.classList.contains('loading');
    if (isLoading) {
      stickyBtn.classList.add('loading');
      stickyBtn.setAttribute('aria-disabled', 'true');
      const spinner = stickyBtn.querySelector('.product-sticky-cta__spinner');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      stickyBtn.classList.remove('loading');
      stickyBtn.removeAttribute('aria-disabled');
      const spinner = stickyBtn.querySelector('.product-sticky-cta__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function syncQuantityToSticky(mainQtyInput, qtyValueEl) {
    if (!mainQtyInput || !qtyValueEl) return;
    const val = mainQtyInput.value;
    if (val !== undefined && val !== '') qtyValueEl.textContent = val;
  }

  function syncQuantityToMain(mainQtyInput, value) {
    if (!mainQtyInput) return;
    const min = parseInt(mainQtyInput.getAttribute('data-min') || mainQtyInput.min || '1', 10);
    const maxAttr = mainQtyInput.getAttribute('data-max') || mainQtyInput.getAttribute('max');
    const max = maxAttr != null ? parseInt(maxAttr, 10) : null;
    const step = parseInt(mainQtyInput.getAttribute('step') || '1', 10);
    let num = parseInt(value, 10);
    if (isNaN(num)) num = min;
    num = Math.max(min, num);
    if (max != null) num = Math.min(max, num);
    const remainder = (num - min) % step;
    if (remainder !== 0) num = num - remainder;
    mainQtyInput.value = String(num);
    mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    return num;
  }

  function initStickyCta(container) {
    const stickyCta = container.querySelector('.product-sticky-cta');
    if (!stickyCta) return;

    const sectionId = stickyCta.dataset.sectionId || (stickyCta.id && stickyCta.id.replace('ProductStickyCTA-', ''));
    const mainSubmitBtn = sectionId ? document.getElementById('ProductSubmitButton-' + sectionId) : null;
    const mainQtyInput = sectionId ? document.getElementById('Quantity-' + sectionId) : null;
    const stickyBtn = stickyCta.querySelector('[data-sticky-cta-trigger]');
    const qtyValueEl = stickyCta.querySelector('[data-sticky-qty-value]');
    const qtyMinus = stickyCta.querySelector('[data-sticky-qty-minus]');
    const qtyPlus = stickyCta.querySelector('[data-sticky-qty-plus]');

    if (!stickyBtn) return;

    function refreshStickyQuantity() {
      syncQuantityToSticky(mainQtyInput, qtyValueEl);
    }

    updateStickyCtaVisibility(stickyCta);
    refreshStickyQuantity();

    window.addEventListener('scroll', function () {
      updateStickyCtaVisibility(stickyCta);
      if (stickyCta.classList.contains('is-visible')) refreshStickyQuantity();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateStickyCtaVisibility(stickyCta);
      if (stickyCta.classList.contains('is-visible')) refreshStickyQuantity();
    });

    if (mainQtyInput && qtyValueEl) {
      qtyMinus && qtyMinus.addEventListener('click', function () {
        const current = parseInt(mainQtyInput.value, 10) || 1;
        const step = parseInt(mainQtyInput.getAttribute('step') || '1', 10);
        const next = syncQuantityToMain(mainQtyInput, current - step);
        qtyValueEl.textContent = String(next);
      });
      qtyPlus && qtyPlus.addEventListener('click', function () {
        const current = parseInt(mainQtyInput.value, 10) || 1;
        const step = parseInt(mainQtyInput.getAttribute('step') || '1', 10);
        const next = syncQuantityToMain(mainQtyInput, current + step);
        qtyValueEl.textContent = String(next);
      });
      mainQtyInput.addEventListener('change', function () { syncQuantityToSticky(mainQtyInput, qtyValueEl); });
      mainQtyInput.addEventListener('input', function () { syncQuantityToSticky(mainQtyInput, qtyValueEl); });
    }

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.classList.contains('loading')) return;
      if (mainSubmitBtn && !mainSubmitBtn.disabled && mainSubmitBtn.getAttribute('aria-disabled') !== 'true') {
        mainSubmitBtn.click();
      }
    });

    if (mainSubmitBtn) {
      syncStickyButtonLoading(stickyBtn, mainSubmitBtn);
      const observer = new MutationObserver(function () {
        syncStickyButtonLoading(stickyBtn, mainSubmitBtn);
      });
      observer.observe(mainSubmitBtn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    }
  }

  function init() {
    const productInfo = document.querySelector('product-info.product-sec');
    if (productInfo) initStickyCta(productInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
